import { httpDelete, httpGet, httpPost, httpPut } from '../http-requests'

const URL = '/api/blogposts'

export async function getBlogs() {
    const response = await httpGet(`${URL}/blogs`);
    return response.status === 200 ? response.data : [];
}

export async function getAllBlogs(token) {
    const response = await httpGet(`${URL}/allBlogs`, token);
    return response.status === 200 ? response.data : [];
}

export async function getBlog(id) {
    const response = await httpGet(`${URL}/${id}`)
    return response.status === 200 ? response.data : [];
}

export async function getLatestBlogs() {
    const response = await httpGet(`${URL}/latest`)
    return response.status === 200 ? response.data : [];
}

export async function postBlog(blogObject, token) {
    return await httpPost(`${URL}`, token, blogObject);
}

export async function putBlog(id, token, blogObject) {
    return await httpPut(`${URL}/${id}`, token, blogObject);
}

export async function deleteBlog(id, token) {
    return await httpDelete(`${URL}/${id}`, token);
}

export async function postBlogMainImage(blogId, formData, token) {
    const response = await httpPost(`${URL}/${blogId}/mainImage`, token, formData);
    return response.status === 201 ? response.data : [];
}

export async function postBlogImage(blogId, formData, token) {
    const response = await httpPost(`${URL}/${blogId}/image`, token, formData);
    return response.status === 201 ? response.data : [];
}

export async function initializeBlogPost(token) {
    return await httpPost(`${URL}/initialize`, token);
}

export async function notifyBlogPost(blogId, token) {
    return await httpPut(`${URL}/${blogId}/notify`, token);
}